module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av758-c237e1f01beae6658e243058bc255103.jpg";